import { isEmpty } from 'lodash';
import { User } from 'services/types/ProfileTypes';

export async function followHandler(
  api: any,
  user: User
): Promise<{ isSuccess: boolean; updatedUser: User }> {
  const isFollowing = user.profile?.is_following ?? false;
  let isSuccess = false;
  if (isFollowing) {
    const { error = {} } = await api.profile.unfollowUser(user.id ?? '');
    isSuccess = isEmpty(error);
  } else {
    const { error = {} } = await api.profile.followUser(user.id ?? '');
    isSuccess = isEmpty(error);
  }
  let updatedUser = { ...user };
  if (isSuccess && updatedUser.profile) {
    updatedUser.profile.is_following = !isFollowing;
  }
  return { isSuccess, updatedUser };
}

export { };
